export enum EmailRecognition {
  Recognized = 'recognized', // no further check is needed, the email has been fully recognized
  Unrecognized = 'unrecognized', // needs further checks, the email has not been identified at all
  Identified = 'identified', // needs manual recognition, the email has been automatically identified
}
